new WOW().init();

document.addEventListener('DOMContentLoaded', function () {
  const contactForm = document.querySelector(
    '#contactform-footer #contactform',
  );
  const contactClose = document.getElementById('contactclose');
  const contactOpen = document.getElementById('contactopen');

  if (contactForm) contactForm.style.display = 'none';

  if (contactClose) {
    contactClose.addEventListener('click', function () {
      if (contactForm)
        contactForm.style.display =
          contactForm.style.display === 'none' ||
          contactForm.style.display === ''
            ? 'block'
            : 'none';
      if (contactOpen) contactOpen.style.display = 'inline-block';
      this.style.display = 'none';
    });
  }

  if (contactOpen) {
    contactOpen.addEventListener('click', function () {
      if (contactForm)
        contactForm.style.display =
          contactForm.style.display === 'none' ||
          contactForm.style.display === ''
            ? 'block'
            : 'none';
      if (contactClose) {
        contactClose.style.display = 'inline-block';
        contactClose.classList.remove('d-none');
      }
      this.style.display = 'none';
    });
  }

  // Add smooth scrolling to all links
  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    const goTop = document.getElementById('gotop');
    const header = document.querySelector('header');
    const formRehab = document.getElementById('formulario-rehabilitacion');

    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      if (goTop) goTop.style.display = 'block';
      if (header) header.classList.add('scrolling');
      if (formRehab) formRehab.classList.add('scrolling');
    } else {
      if (goTop) goTop.style.display = 'none';
      if (header) header.classList.remove('scrolling');
      if (formRehab) formRehab.classList.remove('scrolling');
    }
  }

  document.querySelectorAll('a.anchor-link').forEach(function (anchor) {
    anchor.addEventListener('click', function (event) {
      if (this.hash !== '') {
        event.preventDefault();
        // Store hash
        var hash = this.hash;
        var target = document.querySelector(hash);

        if (target) {
          window.scrollTo({
            top: target.offsetTop,
            behavior: 'smooth',
          });
          window.location.hash = hash;
        }
      }
      this.blur();
    });
  });

  const navbarCollapses = document.querySelectorAll('.navbar-collapse');
  navbarCollapses.forEach(function (collapse) {
    const navbar = collapse.closest('.navbar') || collapse.parentElement;
    const getToggler = () => {
      if (!navbar) return document.querySelector('button.navbar-toggler');
      return (
        navbar.querySelector('button.navbar-toggler') ||
        document.querySelector('button.navbar-toggler')
      );
    };
    const getScopedElements = (selector) =>
      (navbar || document).querySelectorAll(selector);

    collapse.addEventListener('hide.bs.collapse', function () {
      const toggler = getToggler();
      if (toggler) toggler.blur();
      getScopedElements('.if-not-collapsed').forEach(
        (el) => (el.style.display = 'none'),
      );
      getScopedElements('.if-collapsed').forEach((el) => {
        el.style.display = '';
        el.style.opacity = 0;
        setTimeout(() => (el.style.opacity = 1), 10);
        el.style.transition = 'opacity 0.6s';
      });
    });
    collapse.addEventListener('show.bs.collapse', function () {
      const toggler = getToggler();
      if (toggler) toggler.blur();
      getScopedElements('.if-not-collapsed').forEach((el) => {
        el.style.display = '';
        el.style.opacity = 0;
        setTimeout(() => (el.style.opacity = 1), 10);
        el.style.transition = 'opacity 0.6s';
      });
      getScopedElements('.if-collapsed').forEach(
        (el) => (el.style.display = 'none'),
      );
    });
  });

  /**
   * Menuaren egoeraren arabera UI-a aldatzen duen funtzioa.
   * @param {boolean} isOpen - True menua irekitzen bada, false ixten bada.
   */
  const handleMenuUI = (isOpen) => {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const content = document.getElementById('content');
    const prefooter = document.getElementById('prefooter');
    const footer = document.querySelector('footer');
    const stickyWrapper = document.getElementById('sticky-header-wrapper');

    // Segurtasun egiaztapena: elementua badago, aldatu
    if (isMobile) {
      const displayStyle = isOpen ? 'none' : '';
      if (content) content.style.display = displayStyle;
      if (prefooter) prefooter.style.display = displayStyle;
      if (footer) footer.style.display = displayStyle;
    } else {
      if (content) {
        isOpen
          ? content.classList.add('shadowcontent')
          : content.classList.remove('shadowcontent');
      }
    }

    // Sticky-top kudeaketa segurua
    if (stickyWrapper) {
      isOpen
        ? stickyWrapper.classList.remove('sticky-top')
        : stickyWrapper.classList.add('sticky-top');
    }

    if (isOpen) window.scrollTo(0, 0);
  };

  // Deitu funtzioari gertaeren arabera
  // headermenu.addEventListener('shown.bs.collapse', () => handleMenuUI(true));
  // headermenu.addEventListener('hidden.bs.collapse', () => handleMenuUI(false));

  if (document.getElementsByClassName('.lightgallery a')) {
    let gallery = new SimpleLightbox('.lightgallery a', { overlayOpacity: 1 });
  }
});
